export const whyChooseRFData = {
  title: 'Why Choose Rumble Fish Over Synthetic Data Platforms?',
  headers: ['Synthetic Data Platforms', 'Rumble Fish Custom Engineering'],
  rows: [
    {
      syntheticPlatforms: 'Configure pre-built generators',
      rumbleFish: 'Engineer custom solutions for your specific needs',
    },
    {
      syntheticPlatforms: 'Often limited to structured/tabular data',
      rumbleFish: 'Multi-modal: text, images, video, structured data',
    },
    {
      syntheticPlatforms: 'Generic industry templates',
      rumbleFish: 'Domain-specific intelligence built in',
    },
    {
      syntheticPlatforms: 'Self-service (you figure it out)',
      rumbleFish: 'True partnership - we take full ownership',
    },
    {
      syntheticPlatforms: 'Subscription pricing per row/GB',
      rumbleFish: 'Project-based pricing, <b>you own the solution</b>',
    },
    {
      syntheticPlatforms: 'Works for common use cases',
      rumbleFish: 'Excels at complex, unique requirements',
    },
  ],
};
